import React, { Component, Fragment } from 'react';
import { message, Button, Modal, Form as AntForm, Input } from 'antd';
import { FormComponentProps } from 'antd/es/form';
import { services } from '@comall-backend-builder/core';
import './index.less';
import { errorHandle } from '../../services';

const api = services.api;

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
    },
};

// 是否大于0
const isGreaterThanZero = /^(?!0\d*)0?\.\d*[1-9]\d*$|^[1-9]\d*(\.\d+)?$/;

// 执行单价不能大于电商原价
const validatePrice = (value: number, originalPrice: number) => {
    if (value > originalPrice) {
        return Promise.reject(new Error('执行单价不能大于电商原价'));
    }
    return Promise.resolve();
};

export interface CategoryFilterAttrTableProps {
    form: FormComponentProps['form'];
    submit: any;
    useExecutePrice: string;
}

interface IState {
    visible: boolean;
    choiseProduct: object;
    quantity: number;
    executePrice: number;
}

class productModel extends Component<CategoryFilterAttrTableProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            visible: false,
            // 所选商品组合单项
            choiseProduct: {},
            quantity: 0, // 购买数量
            executePrice: 0, // 执行单价
        };
    }

    componentDidUpdate(
        _: Readonly<CategoryFilterAttrTableProps>,
        prevState: Readonly<IState>
    ): void {
        const { quantity, executePrice, choiseProduct } = this.state;

        if (
            (quantity !== prevState.quantity || executePrice !== prevState.executePrice) &&
            this.props.useExecutePrice === 'true'
        ) {
            let sum = 0;
            if (isNaN(quantity) || isNaN(executePrice)) {
                sum = 0;
            } else if (
                isGreaterThanZero.test(quantity.toString()) &&
                isGreaterThanZero.test(executePrice.toString())
            ) {
                sum = +(quantity * executePrice).toFixed(2);
            } else {
                sum = 0;
            }

            this.props.form.setFieldsValue({ discountPrice: sum.toString() });
        } else if (
            (quantity !== prevState.quantity ||
                choiseProduct['originPrice'] !== prevState.choiseProduct['originPrice']) &&
            this.props.useExecutePrice === 'false'
        ) {
            let sum = 0;
            if (isNaN(quantity) || isNaN(choiseProduct['originPrice'])) {
                sum = 0;
            } else if (
                isGreaterThanZero.test(quantity.toString()) &&
                isGreaterThanZero.test(choiseProduct['originPrice'].toString())
            ) {
                sum = +(quantity * choiseProduct['originPrice']).toFixed(2);
            } else {
                sum = 0;
            }
            this.props.form.setFieldsValue({ discountPrice: sum.toString() });
        }
    }

    showModal = () => {
        if (!this.props.useExecutePrice) {
            Modal.warning({
                centered: true,
                maskClosable: true,
                title: '请先选择是否使用执行价，再添加商品！',
            });
            return;
        }
        this.setState({ visible: true });
    };

    handleOk = () => {
        const { choiseProduct } = this.state;
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                if (choiseProduct['originPrice']) {
                    if (choiseProduct['originPrice'] < values.executePrice) {
                        this.props.form.setFields({
                            executePrice: {
                                value: values.executePrice,
                                errors: [new Error('执行单价不能大于电商原价')],
                            },
                        });
                        return;
                    }
                    this.props.submit({ ...values, ...choiseProduct, date: new Date().getTime() });
                    this.props.form.resetFields();
                    this.setState({
                        visible: false,
                        choiseProduct: {},
                    });
                } else {
                    message.error('请选择商品');
                }
            }
        });
    };

    handleCancel = () => {
        this.props.form.resetFields();
        this.setState({ visible: false, choiseProduct: {} });
    };

    choicePro = () => {
        const { getFieldValue } = this.props.form;
        if (getFieldValue('skuCode')) {
            api.get({}, { apiPath: `/8001/order/products/${getFieldValue('skuCode')}` })
                .then((res: any) => {
                    let paramsItem: any = {};
                    const {
                        id,
                        name,
                        skuCode,
                        salePrice,
                        type,
                        weight,
                        availableStock,
                        showName,
                    } = res.productInfo;
                    console.log('availableStock', availableStock);

                    if (availableStock <= 0) {
                        message.warning('库存不足！');
                        this.props.form.setFields({
                            skuCode: { value: skuCode, errors: [new Error('库存不足！')] },
                        });
                    } else {
                        this.props.form.setFields({ skuCode: { value: skuCode } });
                    }
                    paramsItem.id = id;
                    paramsItem.productName = name;
                    paramsItem.skuCode = skuCode;
                    paramsItem.originPrice = salePrice;
                    paramsItem.skuType = type;
                    paramsItem.weight = weight;
                    paramsItem.availableStock = availableStock;
                    paramsItem.showName = showName || '';
                    this.setState({ choiseProduct: paramsItem });
                })
                .catch(errorHandle);
        } else {
            message.error('请输入SKU编码');
        }
    };

    setData = (key: string, value: any) => this.setState({ [key]: value } as any);

    render() {
        const { visible, choiseProduct } = this.state;
        const { getFieldDecorator } = this.props.form;

        return (
            <Fragment>
                <Button type="primary" onClick={this.showModal}>
                    添加商品
                </Button>
                <Modal
                    title="新增商品"
                    centered
                    visible={visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                >
                    <AntForm {...formItemLayout}>
                        <AntForm.Item label="商品SKU">
                            {getFieldDecorator('skuCode', {
                                rules: [
                                    { required: true, message: '请输入需要查询的商品SKU' },
                                    {
                                        validator: () => {
                                            if ((choiseProduct as any)?.availableStock <= 0) {
                                                return Promise.reject(new Error('库存不足'));
                                            }
                                            return Promise.resolve();
                                        },
                                    },
                                ],
                            })(
                                <Input
                                    style={{ width: 200, marginRight: 16 }}
                                    placeholder="请填写商品SKU"
                                />
                            )}
                            <div style={{ display: 'inline' }}>
                                <Button type="primary" onClick={this.choicePro}>
                                    选择商品
                                </Button>
                            </div>
                        </AntForm.Item>
                        <AntForm.Item label="商品名称">
                            <div>{choiseProduct['productName']}</div>
                        </AntForm.Item>
                        <AntForm.Item label="展示名称">
                            <div>{choiseProduct['showName']}</div>
                        </AntForm.Item>
                        <AntForm.Item label="电商原价">
                            <div>{choiseProduct['originPrice']}</div>
                        </AntForm.Item>
                        <AntForm.Item label="购买数量">
                            {getFieldDecorator('quantity', {
                                rules: [
                                    { required: true, message: '请输入购买数量' },
                                    { pattern: isGreaterThanZero, message: '购买数量格式不正确' },
                                ],
                            })(
                                <Input
                                    style={{ width: 300, marginRight: 16 }}
                                    placeholder="请填写购买数量"
                                    onChange={({ target }) =>
                                        this.setData('quantity', target.value)
                                    }
                                />
                            )}
                        </AntForm.Item>
                        {this.props.useExecutePrice === 'true' && (
                            <AntForm.Item label="执行单价">
                                {getFieldDecorator('executePrice', {
                                    rules: [
                                        { required: true, message: '请输入执行单价' },
                                        {
                                            pattern: isGreaterThanZero,
                                            message: '执行单价格式不正确',
                                        },
                                        {
                                            validator: (_, value) =>
                                                validatePrice(value, choiseProduct['originPrice']),
                                            message: '执行单价不能大于电商原价',
                                        },
                                    ],
                                })(
                                    <Input
                                        style={{ width: 300, marginRight: 16 }}
                                        placeholder="请填写执行单价"
                                        onChange={({ target }) =>
                                            this.setData('executePrice', target.value)
                                        }
                                    />
                                )}
                            </AntForm.Item>
                        )}

                        <AntForm.Item label="商品项总价">
                            {getFieldDecorator('discountPrice')(
                                <Input disabled={true} style={{ width: 300, marginRight: 16 }} />
                            )}
                        </AntForm.Item>
                    </AntForm>
                </Modal>
            </Fragment>
        );
    }
}

export const ProductModel = AntForm.create<CategoryFilterAttrTableProps>()(productModel);
